import { render, staticRenderFns } from "./MacroAnalysisInfoDataDownload.vue?vue&type=template&id=2b3e1042&scoped=true"
import script from "./MacroAnalysisInfoDataDownload.vue?vue&type=script&lang=js"
export * from "./MacroAnalysisInfoDataDownload.vue?vue&type=script&lang=js"
import style0 from "./MacroAnalysisInfoDataDownload.vue?vue&type=style&index=0&id=2b3e1042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3e1042",
  null
  
)

export default component.exports